//react-components
import React from "react";
import { NavLink } from "react-router-dom";
import Row from "react-bootstrap/Row";

//assets
import Menu from "../Assets/images/ic_menu.svg";
import Close from "../Assets/images/ic_menu_close.svg";
import Home from "../Assets/images/ic_menu_dashboard_normal.svg";
import UserManagement from "../Assets/images/ic_menu_user_management_normal.svg";
import LOAN_PORTFOLIO from "../Assets/images/ic_menu_loans_cards.svg";
//styles
import "./Sidebar.scss";

//constants
import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";
import { APPLICATION_VERSION } from "../Utils/Constants";
import { Strings } from "../Translations/i18n";

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this._allFeatures = {
      LOAN_PORTFOLIO: {
        id: 1,
        featureName: "Cartera de préstamos",
        menuIcon: LOAN_PORTFOLIO,
        ID: "loanPortfolio",
        to: APPLICATION_CONFIGURATIONS.path.loanPortfolio,
      },
      USER_MANAGEMENT: {
        id: 2,
        featureName: "Gestion de Usuario",
        menuIcon: UserManagement,
        ID: "userManagement",
        to: APPLICATION_CONFIGURATIONS.path.userList,
      },
      DASHBOARD: {
        id: 3,
        featureName: "Inicio - EuroFinance",
        menuIcon: Home,
        ID: "startEF",
        to: APPLICATION_CONFIGURATIONS.path.dashboard,
      },
      DASHBOARD_APPRESTA: {
        id: 3,
        featureName: "Inicio - Appresta",
        menuIcon: Home,
        ID: "startApp",
        to: APPLICATION_CONFIGURATIONS.path.dashboardAppresta,
      },
    };
    this.roleFeature = {
      ADMIN: ["DASHBOARD", "DASHBOARD_APPRESTA", "USER_MANAGEMENT"],
      GENERAL_MANAGER: ["DASHBOARD", "USER_MANAGEMENT"],
      LOAN_PORTFOLIO_MANAGER: ["LOAN_PORTFOLIO"],
    };
    this.state = {
      showMenu: false,
    };
  }

  componentDidMount() {
    document.addEventListener(
      "click",
      this.handleClickOutside.bind(this),
      true
    );
  }

  componentWillUnmount() {
    document.removeEventListener(
      "click",
      this.handleClickOutside.bind(this),
      true
    );
  }
  toggleMenu = () => {
    this.setState({ showMenu: !this.state.showMenu });
  };
  handleClickOutside(event) {
    if (this.state.showMenu) this.setState({ showMenu: !this.state.showMenu });
  }

  render() {
    return (
      <nav
        className={
          (this.state.showMenu
            ? "sidebarMenuExpanded"
            : "sidebarMenuCollapsed") + " sidebar "
        }
      >
        {this.state.showMenu && (
          <img
            src={Close}
            onClick={this.toggleMenu}
            className="menuIcon"
            alt=""
          />
        )}
        {!this.state.showMenu && (
          <img
            src={Menu}
            onClick={this.toggleMenu}
            className="closeIcon"
            alt=""
          />
        )}
        {this.props.loginReducer.userName && (
          <ul>
            {this.roleFeature[this.props.loginReducer.authority].map((Item) => {
              let menu;
              menu = this._allFeatures[Item].to;
              return (
                <li className="home">
                  <NavLink
                    to={menu}
                    title={this._allFeatures[Item].featureName}
                    activeClassName="active-nav"
                    exact
                  >
                    <img
                      src={this._allFeatures[Item].menuIcon}
                      className="menuIcon"
                      alt=""
                    />
                    {this.state.showMenu && (
                      <span>{Strings(this._allFeatures[Item].ID)}</span>
                    )}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        )}
        {this.state.showMenu && (
          <Row className="UIVersion">v{APPLICATION_VERSION}</Row>
        )}
      </nav>
    );
  }
}

export default Sidebar;
